<template>
    <div>

        <div>
            <div v-if="add.page=='goods'">
                <div class="dfjc">
                    <div style="margin-bottom: 10px;">
                        <el-radio-group v-model="type" @input="typeChange">
                            <el-radio :label='2'>按申购单选</el-radio>
                            <el-radio :label='1'>按品种选</el-radio>
                        </el-radio-group>
                        <el-checkbox v-model="merge" v-if="type==1">合并品种</el-checkbox>
<!--                        <el-radio-group >-->
<!--                            <el-radio :label='1'>合并品种</el-radio>-->
<!--                            <el-radio :label='2'>不合并品种</el-radio>-->
<!--                        </el-radio-group>-->
                    </div>
                    <div v-if="type==1" style="margin-bottom: 10px">
                        <span>搜索品种</span>
                        <el-input style="width: 220px"　size="mini"　class="input"　placeholder="输入品名"　v-model="pzSearchData"　clearable></el-input>
                        <el-button class="mrl20" style="margin-left: 10px" icon="el-icon-search" circle  @click="pzSearchFun" size="mini"></el-button>
                    </div>
                    <div  v-if="type==2" style="margin-bottom: 10px;">
                        <span>搜索申购单</span>
                        <el-input style="width: 220px"　size="mini"　class="input"　placeholder="申购人/品名"　v-model="sgSearchData"　clearable></el-input>
                        <el-button class="mrl20" style="margin-left: 10px" icon="el-icon-search" circle  @click="sgSearchFun" size="mini"></el-button>
                    </div>
                </div>
                <div v-if="type==1">
                    <el-table border
                              ref="table"
                              size="mini"
                              :data="pzTableData"
                              :height="tableHeight"
                              @row-click="choosePz"
                              :header-cell-style="{background:'#eef1f6',color:'#000'}"
                              :highlight-current-row="true">
                        <el-table-column type="index" :label="$t('form_serial_number')"  width="45" show-overflow-tooltip> </el-table-column>
                        <el-table-column  prop="name" label="品种" show-overflow-tooltip> </el-table-column>
                        <el-table-column  prop="model" label="规格" show-overflow-tooltip> </el-table-column>
                        <el-table-column  prop="unit" label="单位"></el-table-column>
                        <el-table-column prop="f_num"　label="需求量"　width="120px">
                        </el-table-column>
                    </el-table>
                    <el-pagination  style="margin-top: 10px;text-align: right"
                                    background
                                    @current-change="pzPageCurrentChange"
                                    layout="total,prev, pager, next"
                                    :current-page.sync="pzCurrentPage"
                                    :total="pzTotal"
                                    :page-size="pageSize">
                    </el-pagination>
                </div>
                <div v-if="type==2">
                    <el-table
                            border
                            ref="table"
                            size="mini"
                            :data="sgList"
                            :height="tableHeight"
                            @row-click="chooseSg"
                            :header-cell-style="{background:'#eef1f6',color:'#000'}"
                            :highlight-current-row="true">
                        <el-table-column  label="编号"  align="center"  prop="i_id" show-overflow-tooltip>  </el-table-column>
                        <el-table-column label="申购公司" prop="apply_ent_name" show-overflow-tooltip>  </el-table-column>
                        <el-table-column label="申购部门"  prop="depart_name" show-overflow-tooltip> </el-table-column>
                        <el-table-column  label="申购人" prop="applicant_name" show-overflow-tooltip> </el-table-column>
                        <el-table-column align="center"  label="申请日期"   prop="apply_date" show-overflow-tooltip></el-table-column>
                        <el-table-column align="center" label="截止日期"  prop="end_date" show-overflow-tooltip></el-table-column>
                    </el-table>
                    <el-pagination  style="margin-top: 10px;text-align: right"
                                    background
                                    @current-change="sgPageCurrentChange"
                                    layout="total,prev, pager, next"
                                    :current-page.sync="sgCurrentPage"
                                    :total="sgTotal"
                                    :page-size="pageSize">
                    </el-pagination>
                </div>
                <div style="margin-bottom: 10px;">
                    <!--                <el-button @click="comformPz">添加到品种列表</el-button>-->
                    <!--                <el-button  @click="addSg"  size="mini" >追加</el-button>-->
                    <!--                <el-button  @click="cancelSg"  size="mini"  >追加</el-button>-->

                </div>
            </div>

            <el-table border
                    ref="sgtable1"
                    size="mini"
                      :data="sgTableData"
                    :height="tableHeight"
                    @selection-change="selectSg"
                    :header-cell-style="{background:'#eef1f6',color:'#000'}"
                    :highlight-current-row="true">
                <el-table-column type="selection"  width="40" :selectable="selectable"> </el-table-column>
                <el-table-column  label="编号"  align="center"  prop="i_appid" show-overflow-tooltip>  </el-table-column>
                <el-table-column label="申购公司" prop="apply_ent_name" show-overflow-tooltip>  </el-table-column>
                <el-table-column label="申购部门"  prop="depart_name" show-overflow-tooltip> </el-table-column>
                <el-table-column  label="申购人" prop="applicant_name" show-overflow-tooltip> </el-table-column>
                <el-table-column  prop="vc_pzname" label="品种" show-overflow-tooltip> </el-table-column>
                <el-table-column  prop="vc_bzstyle" label="规格" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="f_reqnum" label="需求量" width="120px"></el-table-column>
<!--                <el-table-column prop="f_num" label="本次需求量" width="120px"></el-table-column>-->
                <el-table-column  prop="vc_unit" label="单位"></el-table-column>
                <el-table-column  prop="vc_reqnote" label="需求说明"></el-table-column>
                <el-table-column align="center"  label="申请日期"   prop="apply_date" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="截止日期"  prop="end_date" show-overflow-tooltip> </el-table-column>
            </el-table>
        </div>
        <div class="center"style="margin-top: 15px;">
            <el-button @click="save" :class="baseerp+'btn'" size="small">
                确认并返回
            </el-button>
            <el-button @click="cancel" size="small">返回</el-button>

        </div>
    </div>
</template>

<script>
    import * as API from "../../api"
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "sgList",
        components: {},
        props:{
            add:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                pzTableData:[],
                sgList:[],
                sgTableData:[],
                pzSearchData:'',
                sgSearchData:'',
                baseerp:'',
                pzitem:[],
                pzCurrentPage:1,
                sgCurrentPage:1,
                pageSize:12,
                pzTotal:0,
                sgTotal:0,
                tableHeight:0,
                type:1,
                merge:false,
                zj:true,
                sgIdarr:[],
                pzIdarr:[],
                dialogChooose:false,
                selectSgData:[],
               backsgList:[],
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.$refs.sgtable1.clearSelection();

            this.$nextTick(()=>{
                this.onResize();
                this.backapplys=JSON.parse(JSON.stringify(this.add.applys));
                if(this.add.page=='applys'){
                    this.type=1
                    this.pzid=this.backapplys[0].i_pzid
                    this.sgid=null
                    this.applyList()
                }else{
                    if(this.type==1){
                        this.getPzListBySx()
                    }else{
                        this.applyBuyList()
                    }
                }

            })
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h*0.4-50
                if(this.tableHeight<60)this.tableHeight=60
            },
            selectable(row,rowIndex){
                let i=this.backapplys.findIndex(ap=>row.i_appid==ap.i_appid)
                if(i==-1){
                    return true
                }else{
                    return false
                }
            },
            typeChange(val){
                if(val==1){
                    this.getPzListBySx()
                }else{
                    this.applyBuyList()
                }
            },
            cxList(){
                this.dialogChooose=true
                if(this.type==1){
                    this.getPzListBySx()
                }else{
                    this.applyBuyList()
                }
            },
            choosePz(val){
                this.pzid=val.name_id
                this.sgid=null
                this.applyList()
            },
            chooseSg(val){
                this.sgid=val.i_id
                this.pzid=null
                this.applyList()
            },
            selectSg(val) {
                let arr = val, hash = {}, nowarr=[];

                nowarr = arr.reduce((item, next) => {
                    hash[next.i_appid] ? "" : hash[next.i_appid] = true && item.push(next)
                    return item
                }, []);
                this.backsgList=nowarr
                // console.log(this.backsgList,this.backsgList)
            },
            changepzFun(sg){
                let obj={
                    pzId:sg.i_pzid,
                    // num:sg.f_num,
                    pzName:sg.vc_pzname,
                    specification:sg.vc_bzstyle,
                    // f_addnum:sg.f_addnum,
                    unit:sg.vc_unit,
                    vc_note:sg.vc_note,
                    applys:[sg],
                };
                return obj
            },
           handelNum(num,pre=5){
                return Math.round(+num+'e'+pre)/Math.pow(10,pre)
            },
            pzSearchFun(){
                this.pzCurrentPage=1
                this.getPzListBySx();
            },
            sgSearchFun(){
                this.pzCurrentPage=1
                this.applyBuyList()
            },
            async getPzListBySx(){
                let param={
                    i_mid: this.mid,
                    type:1,
                    vc_flags:this.add.vc_flags,
                    currentPage:this.pzCurrentPage,
                    pageSize:this.pageSize,
                    vc_search:this.pzSearchData,
                };
                let res=await API.getPzListBySx(param);
                if ( res.code == 1 ){
                    this.pzTableData=res.data.list
                    this.pzTotal=res.data.total
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async applyBuyList(){
                let param={
                    i_pztype:this.add.i_pztype,
                    i_mid: this.mid,
                    status:'',
                    apply_date:'',
                    end_date:'',
                    currentPage:this.sgCurrentPage,
                    pageSize:this.pageSize,
                    vc_search:this.sgSearchData,
                    i_type:1,
                };
                let res=await API.applyBuyList(param);
                if ( res.code == 1 ){
                    this.sgList =res.data.list
                    this.sgTotal=res.data.total
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async applyList(){
                let search='';
                let param={
                    i_pzid:this.pzid||null,
                    i_pid:this.sgid||null,
                    id:this.add.id
                };
                let res=await API.applyList(param);
                if ( res.code == 1 ){
                    this.sgTableData=res.data
                    if(this.add.page=='applys'){
                        this.sgTableData= this.sgTableData.filter(sg=>!this.add.pzapplys.find(pz=>pz.i_appid==sg.i_appid))
                    }
                    // this.$forceUpdate()
                        let iList=[];
                        for(let i=0;i<this.sgTableData.length;i++){
                            let sg=this.sgTableData[i];
                            for (let j =0;j<this.backapplys.length;j++){
                                let pz=this.backapplys[j]
                                if(sg.i_appid==pz.i_appid){
                                    iList.push(i)
                                }

                            }
                        }
                    this.$nextTick(()=>{
                        for(let i of iList){
                            this.$refs.sgtable1.toggleRowSelection(this.sgTableData[i],true)
                        }

                    });
                    // this.sgTableData=[...this.sgTableData]
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            pzPageCurrentChange(val){
                this.pzCurrentPage=val;
                //调用列表接口
                this.getPzListBySx();
            },
            sgPageCurrentChange(val){
                this.sgCurrentPage=val;
                //调用列表接口
                this.applyBuyList();
            },
            cancel(){
                this.$emit('close','back');

            },
            save(){
                // let narr =[...this.backsgList,...this.backapplys],hash={},nowarr=[];
                // nowarr = narr.reduce((item, next) => {
                //     hash[next.i_appid] ? "" : hash[next.i_appid] = true && item.push(next)
                //     return item
                // }, []);
                // console.log(this.backsgList.length,'this.backsgList.length')
                if (this.type==2){
                    this.merge=false
                }else{

                }
                if(this.backsgList.length>0){
                    let arr=[...this.backsgList];
                    this.$emit('close','save',arr,this.merge);
                }else{
                    this.$message.error('请选择招标产品');
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    .dfjc{
        display: flex;
        justify-content: space-between
    }
    .con{
        /*height: 500px;*/
        overflow-y: auto;
    }
    .center{
        text-align: center;
    }
    .hiscss{
        display: inline-block;
        padding: 3px 5px;
        background-color: #b2b2b2;
        color: white;
        font-size: 12px;
        border-radius: 6px;
        margin: 3px;
    }
    .hisbox{
        min-height: 29px;
        margin-top: 3px;
    }
    .el-button i{
        font-size: 18px;
        font-weight: bold;
    }
    .cell .el-button{
        padding: unset;
    }
</style>